import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { ButtonComponent } from '../../../../common/components/button/button.component';

@Component({
  selector: 'app-republish-prompt',
  standalone: true,
  imports: [MatDialogModule, CommonModule, MatButtonModule, ButtonComponent],
  templateUrl: './republish-prompt.component.html',
  styleUrl: './republish-prompt.component.scss'
})
export class RepublishPromptComponent {
  loggedUserId: any;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<RepublishPromptComponent>,
  ) {
    this.loggedUserId = localStorage.getItem("user_id")
  }

  republishPrompt() {
    const postData = {
      prompt_id: this.data?.prompt_id,
      status: "PUBLISHED",
      curator_user_id: this.loggedUserId,
      source_prompt_id: this.data?.source_prompt_id
    }
    this.dialogRef.close(postData);
  }

  cancelRepublish() {
    this.dialogRef.close();
  }


}
